import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { range } from 'ramda'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'

const Pagination = ({ totalResults, pageSize, onChangePage }) => {
    const totalPages = Math.ceil(totalResults / pageSize)
    const [currentPage, setCurrentPage] = useState(1)
    const [firstTime, setFirstTime] = useState(true)

    const resultsInThisPage =
        currentPage * pageSize < totalResults
            ? pageSize
            : totalResults % pageSize

    const renderSaltPoints = (key, newVal) => (
        <p
            key={key}
            className="relative inline-flex cursor-pointer items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            onClick={() => {
                setCurrentPage(newVal)
            }}
        >
            ...
        </p>
    )

    useEffect(() => {
        if (!firstTime) {
            onChangePage(currentPage)
        }
        setFirstTime(false)
    }, [currentPage])

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1)
        }
    }

    const handleBackPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    const renderPoints = () => {
        let pointsBack = false
        let pointsNext = false
        return range(1, totalPages + 1).map(page => {
            // currentPage 1 - page - 4

            if (page === 1 || page === totalPages) {
                return renderItem(page)
            }
            if (page == 2 && currentPage > 3 && pointsBack == false) {
                pointsBack = true
                return renderSaltPoints('points-back', currentPage - 2)
            }

            if (
                page == totalPages - 1 &&
                currentPage < totalPages - 2 &&
                pointsNext == false
            ) {
                pointsNext = true
                return renderSaltPoints('points-next', currentPage + 2)
            }

            if (
                page >= currentPage - (currentPage == totalPages ? 2 : 1) &&
                page <= currentPage + (currentPage == 1 ? 2 : 1)
            ) {
                return renderItem(page)
            }
        })
    }

    const renderItem = page => (
        <p
            onClick={() => {
                setCurrentPage(page)
            }}
            href="#"
            key={`page-${page}`}
            className={`${
                currentPage !== page ? `z-30 bg-white` : ` bg-grayBackground`
            } border-grayLines cursor-pointer text-black70 hover:bg-gray-50  inline-flex relative items-center px-4 py-2 border text-sm font-medium"`}
        >
            {page}
        </p>
    )

    return (
        <div className="w-full h-auto block">
            <div className="bg-white w-full h-auto p-6 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div className="flex-1 justify-center hidden">
                    <a
                        href="#"
                        className="relative inline-flex items-center px-4 py-2 border border-grayLines text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    >
                        Previous
                    </a>
                    <a
                        href="#"
                        className="ml-3 relative inline-flex items-center px-4 py-2 border border-grayLines text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    >
                        Next
                    </a>
                </div>
                <div className="flex-1 flex md:flex-row flex-col gap-y-4 md:items- items-start justify-between">
                    <div>
                        <p className="text-base text-textDarkGray font-normal">
                            {totalResults > 0 ? (
                                <>
                                    Showing{' '}
                                    <span className="font-medium">
                                        {(currentPage - 1) * pageSize + 1}
                                    </span>{' '}
                                    to{' '}
                                    <span className="font-medium">
                                        {(currentPage - 1) * pageSize +
                                            resultsInThisPage}
                                    </span>{' '}
                                    of{' '}
                                    <span className="font-medium">
                                        {totalResults}
                                    </span>{' '}
                                    results
                                </>
                            ) : (
                                <> No results found</>
                            )}
                        </p>
                    </div>
                    <div>
                        <nav
                            className="relative z-0 inline-flex rounded-md -space-x-px"
                            aria-label="Pagination"
                        >
                            <span
                                onClick={handleBackPage}
                                className="relative inline-flex items-center px-2 py-2 rounded-l-xl border border-grayLines bg-white text-sm font-medium text-black80 hover:bg-gray-50"
                            >
                                <span className="sr-only">Previous</span>
                                <ChevronLeftIcon
                                    className="h-5 w-5 text-black70"
                                    aria-hidden="true"
                                />
                            </span>
                            {renderPoints()}
                            <span
                                onClick={handleNextPage}
                                className="relative inline-flex items-center px-2 py-2 rounded-r-xl border border-grayLines bg-white text-sm font-medium text-black80 hover:bg-gray-50"
                            >
                                <span className="sr-only">Next</span>
                                <ChevronRightIcon
                                    className="h-5 w-5 text-black70"
                                    aria-hidden="true"
                                />
                            </span>
                            {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

Pagination.propTypes = {
    totalResults: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
}

export default Pagination
